// Zentrale Inhalte & Assets der Praxis-Website

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/rr4u114f_image.png",
  heroVideo: "/assets/andrea-hero.mp4",
  avatar: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/09o1buvg_image.png",
  portraitHero: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/09o1buvg_image.png",
  portraitAbout: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/09o1buvg_image.png",
  room: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/aq6yg7sp_image.png",
  atWork: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/xm6g8nno_image.png",
  injection: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/1b02z0f6_image.png",
  selfie: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/op5q4r7y_image.png",
};

export const RESULTS = [
  {
    before: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/jmzj8kmf_image.png",
    after: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/oe7vervi_image.png",
    label: "Lippenunterspritzung mit Hyaluron",
    note: "Natürliches, harmonisches Volumen und eine betonte Lippenkontur. Ergebnisse können individuell variieren.",
  },
];

export const HERO = {
  welcome:
    "Herzlich willkommen in meiner Praxis für Ästhetik und Heilpraktik. Schönheit, Wohlbefinden und Ihre individuellen Bedürfnisse stehen bei mir im Mittelpunkt. Mit Sorgfalt, Erfahrung und viel Feingefühl begleite ich Sie auf Ihrem Weg zu mehr Ausstrahlung und innerem Gleichgewicht. Ich freue mich darauf, Sie persönlich willkommen zu heißen.",
};

export const ABOUT = {
  lead:
    "Seit 2007 bin ich als Heilpraktikerin tätig und begleite Menschen mit Erfahrung, Feingefühl und einem klaren Fokus auf natürliche Ästhetik und ganzheitliches Wohlbefinden.",
  paragraphs: [
    "Ich absolvierte die Ausbildung zur Heilpraktikerin in Berlin und legte die staatliche Prüfung in Stralsund erfolgreich ab.",
    "Über fünf Jahre arbeitete ich eng mit einem Arzt für Traditionelle Chinesische Medizin (TCM) zusammen, wodurch ich wertvolle Einblicke in ganzheitliche Behandlungskonzepte gewinnen konnte. Zusätzlich habe ich Kenntnisse im Bereich der Physiotherapie erworben.",
    "Kontinuierliche Fortbildungen in verschiedenen Heilpraktiken sowie eine mehrjährige intensive Ausbildung im Bereich der medizinischen Ästhetik prägen meine heutige Arbeit. Dabei verbinde ich fachliche Kompetenz mit einem hohen ästhetischen Anspruch für natürliche und harmonische Ergebnisse.",
  ],
  goal:
    "Mein Ziel ist es, Ihre individuelle Schönheit zu unterstreichen und Ihr Wohlbefinden nachhaltig zu stärken.",
};

export const CONTACT = {
  name: "Andrea Rauh-Ambros",
  legalName: "Andrea Rauh",
  title: "Heilpraktikerin",
  phone: "+49 177 5618186",
  phoneHref: "tel:+491775618186",
  whatsapp: "+49 177 5618186",
  whatsappHref: "https://wa.me/491775618186",
  email: "andrea.rauh500@gmail.com",
  emailHref: "mailto:andrea.rauh500@gmail.com",
  addressLine1: "Erlanger Straße 46",
  addressLine2: "90765 Fürth, Bayern",
  mapsQuery: "Erlanger Straße 46, 90765 Fürth",
  instagram: "https://www.instagram.com/praxis_andrea.de",
  facebook: "",
};

export const HOURS = [
  { day: "Termine", time: "nach Vereinbarung" },
];

export const SERVICES = [
  {
    id: "aesthetik",
    title: "Ästhetische Behandlungen",
    tag: "Ästhetik",
    text: "Sanfte, natürliche Behandlungen zur Betonung Ihrer individuellen Schönheit – von Fadenlifting mit PDO-Fäden über Faltenbehandlung bis hin zu Volumenaufbau mit Poly-L-Milchsäure.",
    image: "https://customer-assets.emergentagent.com/job_clinic-hub-331/artifacts/1b02z0f6_image.png",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    id: "heilpraktik",
    title: "Heilpraktik & Naturheilkunde",
    tag: "Heilkunde",
    text: "Ganzheitliche naturheilkundliche Verfahren – Wirbelsäulentherapie nach Dorn, Breuß-Massage, CMD-Behandlung und Kinesiologie für Ihr körperliches Gleichgewicht.",
    image: "https://images.unsplash.com/photo-1596343621063-c7a7aaf37aa6",
    span: "lg:col-span-3",
  },
  {
    id: "beratung",
    title: "Individuelle Beratung",
    tag: "Beratung",
    text: "Jede Behandlung beginnt mit einem ausführlichen, persönlichen Gespräch. Gemeinsam finden wir den Weg, der zu Ihnen und Ihren Zielen passt.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/9bvm9jf6_WhatsApp%20Image%202026-08-08%20at%2014.46.14%20%283%29.webp",
    span: "lg:col-span-3",
  },
  {
    id: "ganzheitlich",
    title: "Ganzheitliche Therapiekonzepte",
    tag: "Ganzheitlich",
    text: "Körper, Geist und Wohlbefinden im Einklang – individuell abgestimmte Therapiekonzepte, die Ästhetik und Gesundheit miteinander verbinden.",
    image: "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxtYXNzYWdlJTIwc3BhJTIwaG9saXN0aWMlMjB0aGVyYXB5fGVufDB8fHx8MTc4MzY2ODE1MXww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-6",
  },
];

export const VALUES = [
  {
    id: "wissen",
    title: "Wissen",
    icon: "BookOpen",
    text: "Fundiertes Fachwissen aus über zwei Jahrzehnten Ausbildung und stetiger Weiterbildung – von der Arzthelferin bis zur Heilpraktikerin.",
  },
  {
    id: "erfahrung",
    title: "Erfahrung",
    icon: "Sparkles",
    text: "Langjährige praktische Erfahrung in Ästhetik und Naturheilkunde, mit einem sicheren Gespür für das, was jedem Menschen guttut.",
  },
  {
    id: "vertrauen",
    title: "Vertrauen",
    icon: "ShieldCheck",
    text: "Ein geschützter Raum, in dem Sie sich wohlfühlen. Diskretion, Ehrlichkeit und Achtsamkeit stehen bei jeder Behandlung an erster Stelle.",
  },
];

export const QUALIFICATIONS = [
  { year: "2000", title: "Ausbildung zur Arzthelferin", place: "Bayerische Landesärztekammer, München" },
  { year: "2007", title: "Erlaubnis zur Ausübung der Heilkunde – Heilpraktikerin", place: "Gesundheitsamt der Hansestadt Stralsund" },
  { year: "2008", title: "Health Kinesiology HK-B1 & HK-B2, Coaching & Supervision", place: "Meridianum-Institut, Schenkenzell" },
  { year: "2010", title: "Wirbelsäulentherapie nach Dorn & Breuß-Massage", place: "Schwabach" },
  { year: "2012", title: "DorSana®-Methode: Körper-Statik & Atlas-Behandlung", place: "Schwabach" },
  { year: "2013", title: "Craniomandibuläre Dysfunktion (CMD)", place: "Schwabach" },
  { year: "2014", title: "Sacrum-Behandlung nach DorSana®", place: "Schwabach" },
  { year: "2019", title: "Craniosacrale Therapie & Ästhetische Medizin (Fett-weg-Spritze)", place: "Paracelsus Heilpraktikerschulen, Nürnberg" },
  { year: "2021", title: "Injektions-Training Poly-L-Milchsäure (Lanluma®) & BBL", place: "VitalM.E.D., Eschborn" },
  { year: "2024", title: "Fadenlifting mit PDO-Fäden & Piercing-Zertifikat", place: "Gesundhaus Lindner · Studio Akademie" },
];

export const CERTIFICATES = [
  { src: "/assets/certs/etermis_merz.jpg", label: "ETERMIS® Injektionsseminar – Merz Aesthetics, Nürnberg (2018)" },
  { src: "/assets/certs/lindner_lippen.jpg", label: "Stumpfe Kanüle & Lippenvolumen – Gesundhaus Lindner (2019)" },
  { src: "/assets/certs/6y4rd3ii.jpg", label: "Heilpraktiker-Erlaubnis – Stralsund (2007)" },
  { src: "/assets/certs/d4g4554d.jpg", label: "Arzthelferin – Bayerische Landesärztekammer (2000)" },
  { src: "/assets/certs/i2l5uojl.jpg", label: "Mitglied im Fachverband Deutscher Heilpraktiker e.V." },
  { src: "/assets/certs/2ksnr9e8.jpg", label: "Coaching & Supervision – Meridianum-Institut (2008)" },
  { src: "/assets/certs/5kx9gsrp.jpg", label: "Wirbelsäulentherapie nach Dorn (2010)" },
  { src: "/assets/certs/cpd0pme3.jpg", label: "DorSana®-Methode – Körper-Statik (2012)" },
  { src: "/assets/certs/jvlxjrqj.jpg", label: "Atlas-Behandlung nach DorSana® (2012)" },
  { src: "/assets/certs/7vthwshe.jpg", label: "Craniomandibuläre Dysfunktion CMD (2013)" },
  { src: "/assets/certs/s23zxw9o.jpg", label: "Sacrum-Behandlung nach DorSana® (2014)" },
  { src: "/assets/certs/5y7momjb.jpg", label: "Craniosacrale Therapie – Paracelsus Schulen (2019)" },
  { src: "/assets/certs/77ifpieg.jpg", label: "Ästhetische Medizin – Paracelsus Schulen (2019)" },
  { src: "/assets/certs/cg6mqvg9.jpg", label: "Poly-L-Milchsäure Injektions-Training (2021)" },
  { src: "/assets/certs/5uw75m9i.jpg", label: "Fadenlifting PDO-Fäden – Gesundhaus Lindner" },
  { src: "/assets/certs/d0prv62r.jpg", label: "Piercing-Zertifikat – Studio Akademie (2024)" },
];

export const GALLERY = [
  { src: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/6a7uh23y_WhatsApp%20Image%202026-08-08%20at%2014.46.14%20%285%29.webp", label: "Behandlungsraum" },
  { src: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/nk22g557_WhatsApp%20Image%202026-08-08%20at%2014.46.14.jpeg", label: "Empfangs- & Wartebereich" },
  { src: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/9bvm9jf6_WhatsApp%20Image%202026-08-08%20at%2014.46.14%20%283%29.webp", label: "Beratungsraum" },
  { src: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/ynj2wlfc_WhatsApp%20Image%202026-08-08%20at%2014.46.14%20%282%29.jpeg", label: "Wartezimmer" },
  { src: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/vpx1b9f8_WhatsApp%20Image%202026-08-08%20at%2014.46.14%20%284%29.webp", label: "Beratung & Ambiente" },
  { src: "https://customer-assets-wrfwihn1.emergentagent.net/job_clinic-hub-331/artifacts/g7l82zs5_WhatsApp%20Image%202026-08-08%20at%2014.46.14%20%281%29.jpeg", label: "Kaffee-Ecke" },
];

export const TESTIMONIALS = [
  { quote: "Ich war jetzt zum zweiten Mal da und bin mehr als zufrieden. Hab mir Lippen und Wangen mit Hyaluron unterspritzen lassen. Sie ist sehr kritisch und überlegt genau, wo und wie sie spritzt. Man merkt sofort, dass sie viel Erfahrung hat. Alles wurde genau mit mir abgesprochen und sie hat meine Vorstellungen und Erwartungen voll erfüllt. Vielen Dank dafür!", author: "Carmen Krüger", detail: "vor 3 Jahren", source: "Google" },
  { quote: "Meine Erfahrungen bei Andrea sind einfach nur positiv. Tolle, erfahrene und mega sympathische Heilpraktikerin, die genau weiß, was sie tut. Sie nimmt sich Zeit und setzt ihre Kompetenz für ein sehr gutes Ergebnis ein. Die Terminvereinbarung läuft reibungslos; sie arbeitet hygienisch und informiert ausführlich. Ich kann sie nur weiterempfehlen!", author: "Carina Müller", detail: "vor einem Monat", source: "Google" },
  { quote: "Sehr zu empfehlen. Ich habe schnell und unkompliziert einen Termin bekommen. Vor Ort wurde ich herzlichst und sehr freundlich empfangen. Die Behandlung lief kompetent und sehr angenehm ab. Sehr gerne wieder!", author: "Bianca Gasser", detail: "vor einem Monat", source: "Google" },
  { quote: "Super schön alles. Frau Rauh Ambros war super nett, einfühlsam und verständnisvoll. Nichts geschah in Hektik. Sie nahm sich viel Zeit für mich und hat eine tolle beruhigende Art. Das Spritzen tat nicht so weh, wie ich dachte. Das Ergebnis ist sehr natürlich und gefällt mir total gut. Ich würde sie jederzeit weiterempfehlen.", author: "Sofie Roth", detail: "vor einem Jahr", source: "Google" },
  { quote: "Frau Ambros Rauh ist äußerst kompetent, nimmt sich viel Zeit für eine ausführliche Beratung und arbeitet mit größter Präzision. Die Behandlung war absolut schmerzfrei und das Ergebnis hat meine Erwartungen übertroffen – meine Haut sieht frisch, strahlend und natürlich verjüngt aus. Ich komme definitiv wieder und kann sie uneingeschränkt weiterempfehlen!", author: "Chr.", detail: "vor einem Jahr", source: "Google" },
  { quote: "Ich war bei Andrea – es ist ein Wunder, was sie machen kann! Sie ist eine wahre Künstlerin! Hyaluron-Behandlung, Fadentechnik. Was dabei rauskommt, kann man kaum glauben. Man sieht sich gerne im Spiegel! Danke!", author: "Edit Jerundow", detail: "vor 3 Jahren", source: "Google" },
  { quote: "Frau Rauh Ambros leistet absolut tolle Arbeit. Ansprechende Praxis, top Produkte, sehr gute Preise, großartige Ergebnisse. Ich komme immer wieder. Persönlich ist sie super nett, empathisch, sympathisch und geht wirklich auf jegliche Kundenwünsche ein. 5 Sterne!", author: "Alexandra Maria V.", detail: "vor 2 Jahren", source: "Local Guide" },
  { quote: "Ich habe mich für eine Unterspritzung bei Frau Rauh Ambros entschieden, um meine Lippen aufzubauen und Unterlider zu reduzieren. Von Anfang an fühlte ich mich in der Praxis gut aufgehoben. Die Behandlung verlief schmerzfrei und in einer angenehmen Atmosphäre. Mit dem Ergebnis bin ich äußerst zufrieden – meine Falten sind deutlich gemildert und das Ergebnis wirkt sehr natürlich. Uneingeschränkt weiterzuempfehlen.", author: "Derya Karadeniz", detail: "vor einem Jahr", source: "Google" },
  { quote: "Ich habe Sie meinen Liebsten schon weiterempfohlen. Sie hat eine sehr nette und ruhige Art, die einem viel Vertrauen schenkt. Wo andere nur mit einer Betäubungscreme arbeiten, spritzt sie ganz vorsichtig und betäubt effektiv. Am Anfang war ich etwas skeptisch, aber dann umso mehr erstaunt. Weder Schmerzen noch blaue Flecken – einfach mega das Ergebnis. Schön, Sie gefunden zu haben!", author: "Ahmet Metin", detail: "vor einem Jahr", source: "Google" },
  { quote: "Ich bin schon seit einigen Jahren bei Frau Rauh Ambros und wurde immer nach meinen Wünschen behandelt. Vor der Behandlung wurde ich immer gut über die Seren und die Unterspritzung aufgeklärt. Die gelernte Heilpraktikerin weiß, welches das richtige Mittel ist. Auch das Ambiente trägt zum Wohlfühlen bei. Ich kann eine Behandlung bei ihr sehr empfehlen.", author: "Brigitte Werner", detail: "vor 3 Wochen", source: "Google" },
  { quote: "Andrea ist sehr nett, erfahren und professionell und gibt einem Sicherheit und Vertrauen. Ich komme immer wieder.", author: "Kristina Schmidt", detail: "vor 3 Jahren", source: "Google" },
  { quote: "War schon mehrfach bei ihr und gehe auch nur noch zu ihr. Sie leistet unglaubliche Arbeit. War noch nie so zufrieden. Lohnt sich in jedem Fall.", author: "Meryem Özcücük", detail: "vor 3 Jahren", source: "Google" },
  { quote: "Ich bin absolut begeistert! Das Ergebnis wirkt sehr natürlich und frisch – genau so, wie ich es mir gewünscht habe. Beratung und Behandlung waren professionell und kompetent. Ich habe mich rundum wohl und gut aufgehoben gefühlt. Klare Empfehlung!", author: "Martina", detail: "vor 106 Tagen", source: "Groupon" },
  { quote: "Ich bin so glücklich, die Andrea Rauh getroffen zu haben. Die Dame hat wirklich goldene Hände. So entspannt war ich noch nie in einer Sitzung. Bei Andrea war es eine sehr schöne und angenehme Sitzung mit guter Erfahrung und sehr menschlich.", author: "Bürk", detail: "vor 159 Tagen", source: "Groupon" },
  { quote: "Ich war sehr zufrieden mit der Behandlung, die ich heute hatte, und die Dame war sehr nett und liebevoll. Danke nochmal!", author: "Ebru Yıldırım", detail: "vor 4 Jahren", source: "Local Guide" },
];

export const TREATMENT_CATEGORIES = [
  {
    id: "aesthetik",
    label: "Ästhetik",
    treatments: [
      {
        name: "Fadenlifting",
        summary:
          "Eine sanfte, minimalinvasive Methode zur Straffung der Haut. Die Behandlung dauert ca. 60 Minuten. Viele meiner Kunden berichten von sichtbaren Verbesserungen, die über ein Jahr anhalten können.",
        details: [
          "Es gibt zwei Hauptarten von Fäden: Mono-Fäden mit sanfter, kollagenanregender Wirkung sowie Zug- bzw. Konturfäden mit kleinen Widerhäkchen, die sofort mechanisch heben.",
          "Mono-Fäden eignen sich besonders für lockeres Gewebe, während Zugfäden bei stärker erschlafftem, schwerem Gewebe eingesetzt werden. Das Ergebnis kann individuell variieren.",
        ],
        meta: "ca. 60 Min · Ergebnis bis über 1 Jahr",
      },
      {
        name: "Falten- & Lippenunterspritzung mit Hyaluron",
        summary:
          "Die Faltenunterspritzung mit Hyaluron kann helfen, Falten wie die Nasolabial- oder Marionettenfalten zu mildern. Die Lippenunterspritzung formt die Lippen, betont die Kontur und verleiht frisches, harmonisches Volumen.",
        details: [
          "Beide Behandlungen sorgen für natürliche Ergebnisse und betonen die individuelle Ausstrahlung Ihrer Gesichtszüge.",
          "Die Behandlung dauert in der Regel zwischen 10 und 45 Minuten. Das Ergebnis ist direkt sichtbar und hält je nach Hauttyp und Region etwa 6 bis 18 Monate an, wobei individuelle Unterschiede möglich sind.",
          "Die Hyaluron-Behandlung eignet sich besonders für Personen, die feine bis ausgeprägte Falten ausgleichen möchten oder ihre Lippenkontur harmonisch betonen wollen. Sie ist nicht geeignet bei aktiven Hauterkrankungen, akuten Entzündungen, Schwangerschaft oder Stillzeit.",
          "Die Behandlung eignet sich für alle, die ein frisches, natürliches Ergebnis wünschen, und erfolgt stets nach ausführlicher Beratung und individueller Abstimmung.",
        ],
        meta: "10–45 Min · Ergebnis 6–18 Monate",
      },
      {
        name: "Vampirlifting (PRP)",
        summary:
          "Das Vampirlifting nutzt körpereigenes, plättchenreiches Blutplasma, das aufbereitet und in die Haut injiziert wird.",
        details: [
          "Die Wachstumsfaktoren im Plasma regen die Kollagenbildung an, verbessern die Hautstruktur und sorgen für ein strahlendes, verjüngtes Aussehen – ganz ohne Fremdstoffe.",
        ],
        meta: "Körpereigenes Plasma · natürlich",
      },
      {
        name: "Bodyforming",
        summary:
          "Durch die gezielte Injektion spezieller Wirkstoffe wird die Fettverteilung im behandelten Bereich harmonisiert. Diese Methode unterstützt eine gezielte Körperformung.",
        details: [
          "Die Ergebnisse können eine bis mehrere Sitzungen benötigen und werden individuell auf Sie abgestimmt.",
          "Bitte beachten Sie, dass es sich um einen medizinisch-ästhetischen Eingriff handelt, der im Rahmen des Off-Label-Use erfolgt. Es werden keine Heilversprechen gemacht, und eine umfassende Aufklärung erfolgt vorab.",
          "Die Behandlung eignet sich für Personen mit lokal begrenzten Fettdepots, vorausgesetzt, sie sind gesundheitlich stabil. Kontraindiziert ist die Behandlung bei Schwangerschaft, Stillzeit, akuten Hautinfektionen oder Blutgerinnungsstörungen.",
          "In der Regel sind Sie bereits nach wenigen Stunden wieder gesellschaftsfähig, eventuelle Rötungen oder kleine Blutergüsse klingen schnell ab.",
        ],
        meta: "Individuell · 1–mehrere Sitzungen",
      },
    ],
  },
  {
    id: "vitalitaet",
    label: "Vitalität & Naturheilkunde",
    treatments: [
      {
        name: "Individuelle Infusionen",
        summary:
          "Manchmal braucht der Körper eine maßgeschneiderte Unterstützung von innen. Meine individuell abgestimmten Infusionen versorgen Sie mit essenziellen Nährstoffen, abgestimmt auf Ihre persönlichen Bedürfnisse.",
        details: [
          "Ob als Beauty-Infusion zur Förderung eines strahlenden Teints, als Detox-Kur oder als Vitalstoffkur – jede Behandlung wird nach einem ausführlichen Beratungsgespräch individuell auf Sie abgestimmt.",
          "Diese Infusionen eignen sich für alle, die ihr Wohlbefinden steigern möchten. Sie sind jedoch nicht geeignet bei Schwangerschaft, Stillzeit oder bekannten Unverträglichkeiten.",
          "Vorab kann eine Blutanalyse stattfinden, um die Mikronährstoffe optimal auf Sie abzustimmen.",
        ],
        meta: "Beauty · Detox · Vitalstoffe",
      },
      {
        name: "Mikronährstoffberatung",
        summary:
          "Eine gezielte Analyse Ihres individuellen Nährstoffbedarfs – die Basis für Vitalität und Wohlbefinden von innen heraus.",
        details: [
          "Ob als Beauty-Ansatz zur Förderung eines strahlenden Teints, als Detox-Kur oder als Vitalstoffkur – jede Empfehlung wird nach einem ausführlichen Beratungsgespräch individuell auf Sie abgestimmt.",
          "Vorab kann eine Blutanalyse stattfinden, um die Mikronährstoffe optimal auf Sie abzustimmen. Nicht geeignet bei Schwangerschaft, Stillzeit oder bekannten Unverträglichkeiten.",
        ],
        meta: "Analyse · individuelle Abstimmung",
      },
      {
        name: "Blutanalyse",
        summary:
          "Eine Blutanalyse kann wertvolle Hinweise auf den individuellen Nährstoffstatus liefern und als Grundlage für eine persönliche und ganzheitliche Beratung dienen.",
        details: [
          "Je nach Fragestellung können ausgewählte Vitamine, Mineralstoffe, Spurenelemente oder weitere Laborparameter berücksichtigt werden.",
          "Die Ergebnisse ermöglichen eine individuelle Einschätzung und können dabei helfen, Empfehlungen gezielt auf Ihre persönlichen Bedürfnisse abzustimmen. So entsteht ein maßgeschneidertes Konzept, das Ihre Gesundheit und Ihr allgemeines Wohlbefinden sinnvoll begleiten kann.",
          "Die Blutanalyse erfolgt ausschließlich nach einem ausführlichen Beratungsgespräch und wird individuell an Ihre persönlichen Fragestellungen angepasst.",
        ],
        meta: "Nährstoffstatus · Laborparameter",
      },
      {
        name: "Blutegeltherapie",
        summary:
          "Ein traditionelles naturheilkundliches Verfahren, das seit vielen Jahren in der Naturheilkunde eingesetzt wird. Es wird individuell auf Ihre persönliche Situation abgestimmt und erfolgt nach einem ausführlichen Beratungsgespräch.",
        details: [
          "Die Behandlung kann als ergänzende naturheilkundliche Maßnahme dazu beitragen, den Körper in seinen natürlichen Regulationsprozessen zu begleiten und das allgemeine Wohlbefinden zu unterstützen. Ob eine Blutegeltherapie für Sie geeignet ist, wird im Rahmen einer individuellen Anamnese sorgfältig geprüft.",
          "Nicht geeignet ist die Behandlung unter anderem bei Blutgerinnungsstörungen, während der Einnahme bestimmter blutverdünnender Medikamente, bei ausgeprägter Blutarmut sowie während der Schwangerschaft. Vor jeder Behandlung erfolgt eine ausführliche Aufklärung über den Ablauf sowie mögliche Risiken und Kontraindikationen.",
        ],
        meta: "Traditionelle Naturheilkunde",
      },
    ],
  },
];

export const SERVICE_OPTIONS = [  "Ästhetische Behandlung",
  "Heilpraktik & Naturheilkunde",
  "Individuelle Beratung",
  "Ganzheitliche Therapie",
  "Sonstiges",
];
